export default "/images/headline.png?88c89924f9087232d777d07426d81726";